import {
  IDENTITY_RECAPTCHA_KEY,
  IDENTITY_RECAPTCHA_KEY_TEST
} from '../constants';
export const getReCaptchaKey = (): string => {
  return isProduction() ? IDENTITY_RECAPTCHA_KEY : IDENTITY_RECAPTCHA_KEY_TEST;
};

const isProduction = (): boolean => {
  const urlParts = window.location.hostname.split('.');

  if (urlParts[1] === 'dev') {
    return false;
  }
  switch (urlParts[0]) {
    case 'wac':
    case 'qa-wac':
    case 'author':
    case 'proof':
    case 'localhost':
    case 'local':
      return false;
    case 'truth':
    case 'www':
    case 'atlassian':
    case 'bitbucket':
    case 'sourcetreeapp':
    case 'agile':
    case 'git':
    case 'software':
      return true;
    default:
      /* for omlet instances */
      return false;
  }
};
